import type { ComponentType, SVGProps } from "react";
import { NavLink } from "react-router";
import styles from "./TabBar.module.css";

export type TabBarItem = {
  to: string;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
};

/** Navigation / Bottom из Figma (узел 428:2655). */
export function TabBar({ items }: { items: readonly TabBarItem[] }) {
  return (
    <nav className={styles.bar} aria-label="Основная навигация">
      {items.map(({ to, label, icon: Icon }) => (
        <NavLink key={to} to={to} className={({ isActive }) => (isActive ? `${styles.item} ${styles.active}` : styles.item)}>
          <Icon className={styles.icon} />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
